const extend = require('xtend/mutable');
const q = require('queried');
const on = require('emmy/on');
const off = require('emmy/off');
const ajax = require('component-ajax');
const ejs = require('ejs');
const forEach = require('object-foreach');
const moment = require('moment');

const _ = require('./i18n');
const { Formatter, roubleToSign } = require('./utils');

function MovieScheduler(options) {
  if (!(this instanceof MovieScheduler)) return new MovieScheduler(options);
  extend(this, options);
  this.template = template;
}

extend(MovieScheduler.prototype, {

  ajax,

  preloaderClass: '',

  groupByFormatPriority: ['original_language', 'four_dx', 'imax', 'three_d'],

  outputPriority: ['no_group', 'three_d', 'imax', 'four_dx', 'original_language'],

  loadSchedule(dt) {
    const data = dt || {};
    const currentDay = q(`[data-date="${data.date}"]`, this.container);

    this.hideChildren();

    if (currentDay) {
      currentDay.removeAttribute('hidden');
    } else {
      this.showPreloader();
      this.fetch(data, (resp) => {
        this.hidePreloader();
        this.render(this.template, extend(resp, {
          date: data.date,
        }));
      });
    }
  },

  hideChildren() {
    [].forEach.call(this.container.children, (item) => {
      item.setAttribute('hidden', 'hidden');
    });
  },

  showPreloader() {
    let preloader = q('.ms-preloader', this.container);
    if (preloader) {
      preloader.removeAttribute('hidden');
    } else {
      preloader = document.createElement('div');
      preloader.className = `ms-preloader ${this.preloaderClass}`;
      this.container.appendChild(preloader);
    }
  },

  hidePreloader() {
    const preloader = q('.ms-preloader', this.container);
    if (preloader) {
      preloader.setAttribute('hidden', 'hidden');
    }
  },

  fetch(data, callback) {
    this.ajax({
      url: this.url,
      data,
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json',
      success: (resp) => {
        callback(resp);
      },
    });
  },

  render(template, data) {
    data = data || {};

    data.items = data.places || data.movies || [];

    forEach(data.items, (item) => {
      this.groupByFormat(item);
      this.sortByFormat(item);
      if (item.title) {
        item.titleCapitalized = item.title.charAt(0).toUpperCase() + item.title.slice(1);
      }
    });

    const tplData = extend(data, this.templateDependencies, {
      currentTime: +(new Date()),
    });
    this.container.innerHTML += ejs.render(template, tplData);
  },

  groupByFormat(data) {
    if (!data.showings) return;

    data.showingsGroups = {};

    forEach(data.showings, (showing) => {
      let groupedToFormat = false;

      forEach(this.groupByFormatPriority, (format) => {
        if (showing[format] && !groupedToFormat) {
          if (data.showingsGroups[format]) {
            data.showingsGroups[format].push(showing);
          } else {
            data.showingsGroups[format] = [showing];
          }
          groupedToFormat = true;
        }
      });

      if (!groupedToFormat) {
        if (data.showingsGroups.no_group) {
          data.showingsGroups.no_group.push(showing);
        } else {
          data.showingsGroups.no_group = [showing];
        }
      }
    });
  },

  // expects data format from scheduler#groupByFormat method
  sortByFormat(data) {
    data = data || {};

    if (!data.showingsGroups) return;

    data.showingsGroupsSorted = [];

    forEach(data.showingsGroups, (showings, formatName) => {
      forEach(this.outputPriority, (item) => {
        if (item == formatName) {
          data.showingsGroupsSorted.push({
            showings,
            format: formatName,
          });
        }
      });
    });

    data.showingsGroupsSorted = data.showingsGroupsSorted.sort((a, b) => {
      if (this.outputPriority.indexOf(a.format) > this.outputPriority.indexOf(b.format)) {
        return 1;
      }

      return -1;
    });
  },

});

const template = `
<table class="schedule-table" data-date="<%- date %>">
  <% forEach(items, function(item) { %>
    <tr class="schedule-showing-row">
      <td class="schedule-group">
        <a href="<%- item.site_url %>" class="schedule-group-link"><span><%- item.titleCapitalized || item.title %></span></a>
        <% if (item.address) { %>
          <div class="schedule-group-detail">
            <%- item.address %>
            <% if (item.subway) { %>
              <br/>
              <i class="icon-subway <%- item.location %>"></i>&nbsp;<span class="post-detail-text"><%- item.subway %></span>
            <% } %>
          </div>
        <% } else if (item.year) { %>
          <div class="schedule-group-detail">
            <%- item.year %><% if (item.country) { %>, <%- item.country %><% }; if (item.running_time) { %>, <%- _("%s minute", "%s minutes", item.running_time) %><% } %>
          </div>
        <% } %>
      </td>
      <td class="schedule-showings">
        <% forEach(item.showingsGroupsSorted, function(showingsGroup) { %>
          <% if (showingsGroup.format == 'imax') { %>
            <div class="schedule-group-format">
              <%- _('IMAX showings') %>
            </div>
          <% } else if (showingsGroup.format == 'four_dx') { %>
            <div class="schedule-group-format">
              <%- _('4DX showings') %>
            </div>
          <% } else if (showingsGroup.format == 'three_d') { %>
            <div class="schedule-group-format">
              <%- _('3D showings') %>
            </div>
          <% } else if (showingsGroup.format == 'original_language') { %>
            <div class="schedule-group-format">
              <%- _('Showings in the original language') %>
            </div>
          <% } %>
          <ul class="schedule-showings-list">
            <% forEach(showingsGroup.showings, function(showing) { %>

              <li class="schedule-showing<% if (showing.time*1000 < currentTime) { %> schedule-past-showing<% } %>">
                <a <% if (showing.time*1000 < currentTime && typeof(ramblerkassamovie_key) != 'undefined') { %>
                  href="javascript:ticketManager.hallPlanV2(<%- showing.ramblerkassaplace_key %>,<%- ramblerkassamovie_key %>,'<%- moment(showing.time*1000).format('DD-MM-YYYY') %>-<%- moment(showing.time*1000).format('HHmm') %>');"
                <% } else if (showing.time*1000 > currentTime && showing.buy_button_url) { %>
                  href="<%- showing.buy_button_url %>" target="_blank"
                <% } %>

                  class="schedule-showing-link">
                  <span><%- moment(showing.time*1000).format('HH:mm') %></span>

                  <% if (showingsGroup.format != 'imax' && showing.imax) { %>
                    <small class="schedule-feature schedule-feature-imax">IMAX</small>
                  <% } else if (showingsGroup.format != 'four_dx' && showing.four_dx) { %>
                    <small class="schedule-feature">4DX</small>
                  <% } else if (showingsGroup.format != 'three_d' && showingsGroup.format != 'four_dx' && showing.three_d) { %>
                    <small class="schedule-feature">3D</small>
                  <% } else if (showingsGroup.format != 'original_language' && showing.original_language) { %>
                    <small class="schedule-feature">En</small>
                  <% } %>

                  <% if (showing.price) { %>
                    <br/><small class="schedule-showing-price">
                      <%- roubleToSign(showing.price) %>
                    </small>
                  <% } %>
                </a>
              </li>

            <% }); %>
          </ul>
        <% }); %>
      </td>
    </tr>
  <% }); %>
</table>
`;

function initMovieScheduler(schedulesContainer) {
  const tabs = q.all('.schedule-tab');
  const scheduleType = schedulesContainer.getAttribute('data-type');
  const itemId = schedulesContainer.getAttribute('data-id');
  const formatter = new Formatter();

  const scheduler = new MovieScheduler({
    url: '/widgets/movie-showings/',
    container: q('.schedule-tables'),
    templateDependencies: {
      _,
      forEach,
      moment,
      formatMoney: formatter.formatMoney.bind(formatter),
      roubleToSign,
    },
  });

  tabs.forEach((item) => {
    on(item, 'click', () => {
      if (scheduleType == 'place') {
        scheduler.loadSchedule({
          date: item.getAttribute('data-date'),
          place_id: itemId,
          group_by: 'movie',
        });
      } else {
        scheduler.loadSchedule({
          date: item.getAttribute('data-date'),
          movie_id: itemId,
          group_by: 'place',
          location: kudago.location,
        });
      }

      off(window, 'load.scheduler');
    });
  });

  // autoload first tab
  tabs[0].click();
}

module.exports = { MovieScheduler, initMovieScheduler };
